/**
 * Loads @react-pdf/renderer with the one Node global it still reaches for in the browser.
 *
 * @react-pdf/layout 5.2 checks `Buffer.isBuffer(source)` after fetching each image. Its sibling
 * packages bundle their own Buffer and layout does not, so in a browser that line throws
 * "Buffer is not defined": the image still draws, but every export logs the error once per
 * layout pass and the image loses the cache key that lets a repeated image embed once.
 *
 * The real `buffer` package is the implementation those siblings bundle. It is imported here
 * so only a PDF export downloads it, and set on the global only when nothing else has, so any
 * library that later feature-detects `Buffer` finds a complete one rather than a stub.
 */
export async function loadReactPdf(): Promise<typeof import('@react-pdf/renderer')> {
    if (!('Buffer' in globalThis)) {
        // A bare 'buffer' also names Node's built-in module, which Vite swaps for an empty stub
        // whenever the package fails to resolve. The file path can only mean the package.
        const { Buffer } = await import('buffer/index.js');
        Object.defineProperty(globalThis, 'Buffer', {
            value: Buffer,
            writable: true,
            configurable: true,
        });
    }
    return import('@react-pdf/renderer');
}
